export default __webpack_public_path__ + "static/media/Rex.8f195371.png";